import React from 'react';
import './Notification.css';

function Notification() {
  const notifications = [
    'Applications are invited from Bachelor of Naturopathy and Yogic Sciences (BNYS) Graduates from any UGC recognised Universities for Central Registration and Kindly note NRB is also Issuing certificate for those who have already registered with Central Council of Research in Yoga and Naturopathy (CCRYN), New Delhi.',
    'It has been known that some individuals are canvassing people to get Naturopathy Registration Board Certificate for Degree/ Diploma/ Certificate Holder in Naturopathy. Public are hereby instructed not to get deceived with such touting individuals and not to make any payments. At present, Naturopathy Registration Board (NRB) is providing registration to BNYS graduates only and payments are made only through NRB portal. NRB has not authorized anybody for making payment.'
  ];

  const marqueeText = notifications.join(' ◆ ');

  return (
    <div className="notification-container">
      <span className="notification-badge">📢</span>
      <div className="marquee-wrapper">
        <div className="marquee">
          <span className="marquee-text">{marqueeText}</span>
          <span className="marquee-text">{marqueeText}</span>
        </div>
      </div>
      {/* Notice links moved to Home.js Notice Board (to avoid top-bar placement) */}
    </div>
  );
}

export default Notification;

